import { Injectable } from '@angular/core';
import { BleClient, BleDevice, ScanResult } from '@capacitor-community/bluetooth-le';

@Injectable({
  providedIn: 'root'
})
export class BluetoothService {

    private initialized = false;
    private isScanning = false;

    async initialize() {
        if (!this.initialized) {
            await BleClient.initialize();
            this.initialized = true;
        }
        const isEnabled = await BleClient.isEnabled();
        if (!isEnabled) {
            console.warn('Bluetooth désactivé');
        }
    }

    private async stopScan(): Promise<void> {
        if (this.isScanning) {
            try {
                await BleClient.stopLEScan();
                console.log('Scan Bluetooth arrêté');
            } catch (e) {
                console.warn('Erreur lors de l\'arrêt du scan:', e);
            } finally {
                this.isScanning = false;
            }
        }
    }

    async scanForLecteur(lecteurName: string): Promise<BleDevice | null> {
        if (!lecteurName?.trim()) {
            throw new Error('Nom du lecteur requis');
        }

        await this.initialize();
        await this.stopScan();

        return new Promise((resolve, reject) => {
            let resolved = false;
            let timeoutId: NodeJS.Timeout;
            
            const cleanup = async (result: BleDevice | null, error?: Error) => {
                if (resolved) return;
                resolved = true;
                
                if (timeoutId) clearTimeout(timeoutId);
                console.log('Début de l\'arrêt du scan...');
                await this.stopScan();
                console.log('Scan complètement arrêté');
                
                if (error) {
                    reject(error);
                } else {
                    resolve(result);
                }
            };

            timeoutId = setTimeout(() => {
                console.log(`Timeout: lecteur '${lecteurName}' non trouvé après 10s`);
                cleanup(null);
            }, 10000);

            this.isScanning = true;
            
            BleClient.requestLEScan(
                { allowDuplicates: false },
                (result: ScanResult) => {
                    const device = result.device;
                    console.log(`Appareil scanné: ${device.name || 'Sans nom'} (${device.deviceId})`);

                    if (device.name === lecteurName) {
                        console.log(`Lecteur trouvé: ${lecteurName}`);
                        cleanup(device);
                    }
                }
            ).catch((error) => {
                console.error('Erreur lors du démarrage du scan:', error);
                cleanup(null, error);
            });
        });
    }
}